import React from 'react';
import { Spin } from 'antd';
import './NumberAssignmentProgress.css';

/** Shown in a number assignment modal while the backend moves the number and its contacts */
const NumberAssignmentProgress: React.FC = () => (
  <div className="number-assignment-progress">
    <Spin size="large" />
    <p className="number-assignment-progress__title">Attribution du numéro en cours</p>
    <p className="number-assignment-progress__text">
      Cela peut prendre quelques minutes selon le nombre d'informations à traiter.
      Vous pouvez fermer cette page sans risque, l'opération se poursuit.
    </p>
  </div>
);

export default NumberAssignmentProgress;